import { Injectable } from '@angular/core'
import { Router } from '@angular/router'


@Injectable()
export class NavigationService {

  private previousUrl: string = '';

  constructor(private router:Router) {}

  setBackUrl(url:string):void{
    this.previousUrl = url;
  }

  goBack(fallbackUrl:string = '/'): void {
    this.router.navigateByUrl(this.previousUrl ? this.previousUrl : fallbackUrl)
  }

}